module.exports = __webpack_public_path__ + "static/VWT20_Funktion05_Einschenken_800x800-200x200-a946ffb5f00421c0b8d7ea4047393213.png";